<div class="container card mt-3">
  <div class="card-header d-inline-flex">
    <div> Create New Campaign</div>
    <button class="btn btn-secondary d-flex align-items-center mb-3 ms-auto" (click)="goBack()">
      <span class="material-icons me-1" title="Go Back">arrow_left</span>
      <span class="font-medium">Back</span>
    </button>
  </div>

  <div class="card-body bg-blue-50">
    <!-- Campaign Name -->
    <div class="mb-3">
      <label class="form-label">Campaign name *</label>
      <input type="text" placeholder="Enter campaign name" [(ngModel)]="campaignName" class="form-control" />
    </div>

    <!-- Create Button -->
    <div class="d-inline-flex w-full mb-2">
      <button class="btn btn-primary d-flex align-items-center" (click)="createCampaign()" [disabled]="isCreateDisabled || !campaignName.trim()">
        <span class="font-medium">Create Campaign</span>
      </button>
    </div>

    <!-- Success Message -->
    <div *ngIf="campaignCreated" class="alert alert-success">
      <i class="pi pi-check-circle me-2"></i>
      Campaign created successfully! Redirecting to edit page...
    </div>
  </div>

</div>
